import { SimpleModel } from 'model/SimpleModel';

import { Logic } from './Logic';
import { LogicDependencyMode } from './LogicDependencyMode';
import { LogicType } from './LogicType';

export namespace LogicDependency {
  export interface Shape extends Logic.Shape {
    questionId: number;
    options?: number[];
    mode?: LogicDependencyMode;
  }
}

export class LogicDependency extends Logic<LogicDependency.Shape> {
  constructor(initialData: SimpleModel.Data<LogicDependency.Shape>) {
    super(initialData, LogicType.Dependency);
  }

  getQuestionId(): number {
    return this.get('questionId');
  }

  setOptions(options: number[]): this {
    return this.set('options', options);
  }

  getOptions(): number[] {
    return this.get('options', []);
  }

  getMode(): LogicDependencyMode {
    return this.get('mode', LogicDependencyMode.AllEqual);
  }

  setMode(mode: LogicDependencyMode): this {
    return this.set('mode', mode);
  }
}
